import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface RevokePersonalAccessTokenParams {
    refreshToken: string;
}

export interface RevokePersonalAccessTokenResult  extends IResult {
}

export class RevokePersonalAccessTokenRequest extends Request<RevokePersonalAccessTokenParams, RevokePersonalAccessTokenResult> {
  constructor(params: RevokePersonalAccessTokenParams) {
    super('revokePersonalAccessToken', params);
  }
}
